"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ProfilePhoto = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ProfilePhoto"));
var _OverviewRow = _interopRequireDefault(require("../OverviewRow"));
var styles = {
  "icon": "icon_cMXDOq",
  "profile-container": "profile-container_fMWSU8",
  "profileContainer": "profile-container_fMWSU8",
  "custom-profile": "custom-profile_iBa2Fl",
  "customProfile": "custom-profile_iBa2Fl"
}; 
require('./OverviewPublishedBy.css');
var OverviewPublishedBy = function OverviewPublishedBy(_ref) {
  var asset = _ref.asset;
  if (!asset.createdBy) {
    return null;
  }
  var _asset$createdBy = asset.createdBy,
    firstName = _asset$createdBy.firstName,
    lastName = _asset$createdBy.lastName;
  var createdByLabel = "".concat(firstName, " ").concat(lastName);
  return /*#__PURE__*/_react.default.createElement(_OverviewRow.default, {
    title: "Published by",
    testId: "asset-created-by"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.profileContainer
  }, /*#__PURE__*/_react.default.createElement(_ProfilePhoto.default, {
    testId: "assets",
    className: (0, _classnames.default)('fs-block', styles.icon, styles.customProfile),
    size: "s",
    firstName: firstName,
    lastName: lastName,
    "aria-hidden": true
  }), !!asset.createdBy ? /*#__PURE__*/_react.default.createElement("span", {
    title: createdByLabel,
    className: "fs-block"
  }, createdByLabel) : null));
};
var _default = exports.default = OverviewPublishedBy;
//# sourceMappingURL=OverviewPublishedBy.js.map